import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { List } from 'immutable';
import { IIcon } from '../icon/icon.component';

export interface ICheckmarkItem {
  value: string;
  icon?: IIcon;
}

@Component({
  selector: 'i2g-checkmark-list',
  templateUrl: './checkmark-list.component.html',
  styleUrls: ['./checkmark-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckmarkListComponent implements OnInit {
  @Input() items: List<ICheckmarkItem>;
  @Input() htmlContent: boolean;

  constructor() {}

  ngOnInit() {}
}
